import React, { lazy } from "react";
import { Switch, useHistory, useLocation } from "react-router-dom";

import AppLayout from "./layout/AppLayout";
import { Protegerotas } from "./shared/protegerotas";
import { getRoleConfig } from "./routeConfig";
import { getSessionValue } from "../security/session";
import { ROLES } from "../security/roles";

// Alertas do atendimento: vigiam fugas de gás e tickets por triar em todo o
// módulo IRS. Carregado só para esse perfil — ninguém mais paga o polling.
const IrsAlertsProvider = lazy(() => import("./irs/IrsAlertsProvider"));

/**
 * Dashboard — single entry point for all authenticated roles.
 *
 * Reads `grupo` from the secure session helper, picks the matching config from
 * routeConfig.js, and renders the correct sidebar nav + route tree.
 * No role-specific dashboard files needed.
 */
export default function Dashboard() {
  const history = useHistory();
  const location = useLocation();
  const grupo = getSessionValue("grupo", "Operario");
  const config = getRoleConfig(grupo);

  const handleNavClick = (key) => {
    const path = config.keyPaths[key];
    if (path) history.push(path);
  };

  // O título segue a rota quando esta o declara. Sem isto, quem chega por URL
  // ou por um link interno fica com o título da tela anterior no cabeçalho.
  const activeRoute = config.routes.find((route) => route.title && route.path === location.pathname);
  const pageTitle = (activeRoute && activeRoute.title) || config.pageTitle;

  // O provedor tem de envolver o AppLayout, não o conteúdo: é o cabeçalho que
  // consome os alertas, e o modal da fuga precisa de aparecer em qualquer rota.
  const withAlerts = (node) =>
    grupo === ROLES.IRS ? <IrsAlertsProvider>{node}</IrsAlertsProvider> : node;

  return withAlerts(
    <AppLayout
      navItems={config.navItems}
      onNavClick={handleNavClick}
      defaultKey={config.defaultKey}
      pageTitle={pageTitle}
      profilePath={config.profilePath}
    >
      <Switch>
        {config.routes.map(({ path, component, exact, roles = [], permissions = [] }) => (
          <Protegerotas
            key={path}
            path={path}
            exact={!!exact}
            component={component}
            roles={roles}
            permissions={permissions}
          />
        ))}
      </Switch>
    </AppLayout>,
  );
}
